import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import type { SelectOption } from '@rio-cloud/rio-uikit/Select';
import type { IntlShape } from 'react-intl';

import type { TourStatus } from '#domain/model/Tour.ts';

import type { StatusDataRecord } from './StatusOrder.ts';

type FilterProps = {
    values: string[];
    onFilter: (value: string[]) => void;
    options?: SelectOption[];
};
export const Filter = ({ values, onFilter, options }: FilterProps) => (
    <Multiselect
        showSelectedItemIcon
        showUnselectedItemIcons
        pullRight
        value={values}
        options={options}
        onChange={e => onFilter(e)}
    />
);

export const getOption = (status: TourStatus, statusData: StatusDataRecord, intlShape: IntlShape) => ({
    id: status,
    label: intlShape.formatMessage({ id: statusData[status].id }),
    icon: (
        <span
            className={`uikit-icon icon-${statusData[status].icon} text-color-${statusData[status].color} text-size-16`}
        />
    ),
    selected: statusData[status].selected,
});
